var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "crearEndpoint", attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivP" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Crear EndPoint")]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.e1 != 1,
                              expression: "e1 != 1"
                            }
                          ],
                          staticStyle: { "max-height": "75%" },
                          attrs: {
                            color: "#526da5",
                            disabled: _vm.e1 <= 1 || _vm.btnBloquear
                          },
                          on: {
                            click: function($event) {
                              _vm.volver(), _vm.cierraMenuPerfil()
                            }
                          }
                        },
                        [_vm._v("Volver")]
                      ),
                      _vm._v("  \n          "),
                      _vm.e1 < 3
                        ? _c(
                            "v-btn",
                            {
                              class: _vm.btnClass,
                              staticStyle: { "max-height": "75%" },
                              attrs: {
                                disabled: !_vm.validForm || _vm.btnBloquear
                              },
                              on: {
                                click: function($event) {
                                  _vm.continuar(), _vm.cierraMenuPerfil()
                                }
                              }
                            },
                            [_vm._v("Continuar\n          ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              staticStyle: { "max-height": "75%" },
                              attrs: {
                                disabled:
                                  !_vm.validForm || _vm.btnBloquear
                                    ? true
                                    : false
                              },
                              on: {
                                click: function($event) {
                                  _vm.crear(), _vm.cierraMenuPerfil()
                                }
                              }
                            },
                            [_vm._v("\n            Guardar\n          ")]
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.e1,
                    callback: function($$v) {
                      _vm.e1 = $$v
                    },
                    expression: "e1"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.asociarCliente.visible,
                              expression: "asociarCliente.visible"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.asociarCliente.step,
                            step: _vm.asociarCliente.step
                          }
                        },
                        [_vm._v("Cliente")]
                      ),
                      _c("v-divider", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.asociarCliente.visible,
                            expression: "asociarCliente.visible"
                          }
                        ]
                      }),
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.asociarEnpoint.visible,
                              expression: "asociarEnpoint.visible"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.asociarEnpoint.step,
                            step: _vm.asociarEnpoint.step
                          }
                        },
                        [_vm._v("EndPoint")]
                      ),
                      _c("v-divider", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.asociarEnpoint.visible,
                            expression: "asociarEnpoint.visible"
                          }
                        ]
                      }),
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.asociarVehiculos.visible,
                              expression: "asociarVehiculos.visible"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.asociarVehiculos.step,
                            step: _vm.asociarVehiculos.step
                          }
                        },
                        [_vm._v("Vehiculos")]
                      ),
                      _c("v-divider", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.asociarEnpoint.visible &&
                              !_vm.asociarVehiculos.visible,
                            expression:
                              "asociarEnpoint.visible && !asociarVehiculos.visible"
                          }
                        ]
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-items",
                    { staticClass: "cardnew" },
                    [
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.asociarCliente.visible,
                              expression: "asociarCliente.visible"
                            }
                          ],
                          attrs: { step: _vm.asociarCliente.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          staticClass: "col-md-12",
                                          attrs: { "lazy-validation": "" },
                                          model: {
                                            value: _vm.validForm,
                                            callback: function($$v) {
                                              _vm.validForm = $$v
                                            },
                                            expression: "validForm"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-container",
                                            { attrs: { "grid-list-md": "" } },
                                            [
                                              _c(
                                                "div",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { md12: "" } },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "h2_title",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "12px !important"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Seleccionar Cliente\n                          "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                { attrs: { wrap: "" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-autocomplete", {
                                                        attrs: {
                                                          label:
                                                            _vm.formFields
                                                              .clientes.label,
                                                          items:
                                                            _vm.formFields
                                                              .clientes.items,
                                                          "item-text":
                                                            _vm.formFields
                                                              .clientes
                                                              .formatItem,
                                                          "item-value": "id",
                                                          "data-vv-name":
                                                            "selectedValue",
                                                          color: "primary",
                                                          clearable: true,
                                                          "no-data-text":
                                                            "Sin resultados",
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.formFields
                                                              .clientes.value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.formFields
                                                                .clientes,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formFields.clientes.value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.asociarEnpoint.visible,
                              expression: "asociarEnpoint.visible"
                            }
                          ],
                          attrs: { step: _vm.asociarEnpoint.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          staticClass: "col-md-12",
                                          attrs: { "lazy-validation": "" },
                                          model: {
                                            value: _vm.validForm,
                                            callback: function($$v) {
                                              _vm.validForm = $$v
                                            },
                                            expression: "validForm"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-container",
                                            { attrs: { "grid-list-md": "" } },
                                            [
                                              _c(
                                                "div",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { md12: "" } },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "h2_title",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "12px !important"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Seleccionar EndPoint\n                          "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                { attrs: { wrap: "" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-autocomplete", {
                                                        attrs: {
                                                          label:
                                                            _vm.formFields
                                                              .endPoint.label,
                                                          items:
                                                            _vm.formFields
                                                              .endPoint.items,
                                                          "item-text":
                                                            "nombre_ws",
                                                          "item-value": "id",
                                                          "data-vv-name":
                                                            "selectedValue",
                                                          color: "primary",
                                                          clearable: true,
                                                          "no-data-text":
                                                            "Sin resultados",
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.formFields
                                                              .endPoint.value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.formFields
                                                                .endPoint,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formFields.endPoint.value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.asociarVehiculos.visible,
                              expression: "asociarVehiculos.visible"
                            }
                          ],
                          attrs: { step: _vm.asociarVehiculos.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          staticClass: "col-md-12",
                                          attrs: { "lazy-validation": "" },
                                          model: {
                                            value: _vm.validForm,
                                            callback: function($$v) {
                                              _vm.validForm = $$v
                                            },
                                            expression: "validForm"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-container",
                                            { attrs: { "grid-list-md": "" } },
                                            [
                                              _c(
                                                "div",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { md12: "" } },
                                                    [
                                                      _c(
                                                        "h2",
                                                        {
                                                          staticClass:
                                                            "h2_title",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "12px !important"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Seleccionar Vehículos\n                          "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c("br"),
                                              _c(
                                                "v-layout",
                                                { attrs: { wrap: "" } },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-radio-group",
                                                        {
                                                          attrs: { row: "" },
                                                          on: {
                                                            change:
                                                              _vm.selectedRadio
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.selectedItem,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.selectedItem = $$v
                                                            },
                                                            expression:
                                                              "selectedItem"
                                                          }
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label: "Flotas",
                                                              value: "Flotas"
                                                            }
                                                          }),
                                                          _c("v-radio", {
                                                            attrs: {
                                                              label:
                                                                "Vehículos",
                                                              value: "Vehiculos"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm.selectedItem ==
                                                      "Flotas"
                                                        ? _c("v-text-field", {
                                                            attrs: {
                                                              "prepend-icon":
                                                                "drive_eta",
                                                              label:
                                                                "Buscar Flota"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.codeVehiculo,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.codeVehiculo = $$v
                                                              },
                                                              expression:
                                                                "codeVehiculo"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm.selectedItem ==
                                                      "Vehiculos"
                                                        ? _c("v-text-field", {
                                                            attrs: {
                                                              "prepend-icon":
                                                                "drive_eta",
                                                              label:
                                                                "Buscar Vehículo"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.patente,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.patente = $$v
                                                              },
                                                              expression:
                                                                "patente"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        sm12: "",
                                                        md12: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-divider"),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.selectedItem ==
                                                                "Flotas",
                                                              expression:
                                                                "selectedItem == 'Flotas'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "gridcard rounded-card proveedores"
                                                        },
                                                        [
                                                          _c("v-divider"),
                                                          _c("v-data-table", {
                                                            staticClass:
                                                              "elevation-1",
                                                            attrs: {
                                                              headers:
                                                                _vm.headersFlotas,
                                                              items:
                                                                _vm.itemsFlotas,
                                                              pagination:
                                                                _vm.pagination,
                                                              "rows-per-page-items":
                                                                _vm.rowsPerPage,
                                                              "rows-per-page-text":
                                                                "Filas por página",
                                                              search:
                                                                _vm.codeVehiculo
                                                            },
                                                            on: {
                                                              "update:pagination": function(
                                                                $event
                                                              ) {
                                                                _vm.pagination = $event
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "items",
                                                                  fn: function(
                                                                    props
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                props
                                                                                  .item
                                                                                  .flota
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                props
                                                                                  .item
                                                                                  .plataforma
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-checkbox",
                                                                            {
                                                                              attrs: {
                                                                                value: _vm.isSelectedFlota(
                                                                                  props
                                                                                    .item
                                                                                    .flotaid
                                                                                )
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toggleSelectionFlota(
                                                                                    props
                                                                                      .item
                                                                                      .flotaid
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.selected,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selected = $$v
                                                              },
                                                              expression:
                                                                "selected"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.selectedItem ==
                                                                "Vehiculos",
                                                              expression:
                                                                "selectedItem == 'Vehiculos'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "gridcard rounded-card proveedores"
                                                        },
                                                        [
                                                          _c("v-divider"),
                                                          _c("v-data-table", {
                                                            staticClass:
                                                              "elevation-1",
                                                            attrs: {
                                                              headers:
                                                                _vm.headersVehiculos,
                                                              items:
                                                                _vm.itemsVehiculos,
                                                              pagination:
                                                                _vm.pagination,
                                                              "rows-per-page-items":
                                                                _vm.rowsPerPage,
                                                              "group-by":
                                                                "flotaId",
                                                              "rows-per-page-text":
                                                                "Filas por página",
                                                              search:
                                                                _vm.patente
                                                            },
                                                            on: {
                                                              "update:pagination": function(
                                                                $event
                                                              ) {
                                                                _vm.pagination = $event
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "items",
                                                                  fn: function(
                                                                    vehiculo
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                vehiculo
                                                                                  .item
                                                                                  .flota
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                vehiculo
                                                                                  .item
                                                                                  .patente
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                vehiculo
                                                                                  .item
                                                                                  .plataforma
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                vehiculo
                                                                                  .item
                                                                                  .fechaModificacion
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-left"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-checkbox",
                                                                            {
                                                                              attrs: {
                                                                                value: _vm.isSelectedVehiculo(
                                                                                  vehiculo
                                                                                    .item
                                                                                    .id
                                                                                )
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toggleSelectionVehiculo(
                                                                                    vehiculo
                                                                                      .item
                                                                                      .id
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.selected,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.selected = $$v
                                                              },
                                                              expression:
                                                                "selected"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }